import { type UserTasksAndResponses } from '../../../models/userTasksAndResponses';
import { getDateOffset } from '../support/date-utils';

export const baseTasks: UserTasksAndResponses = {
  tasksCount: 6,
  termsAndConditions: {
    submitted: false,
    submissionDate: ''
  },
  firstAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-first-assessment'
  },
  midCohortGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-mid-cohort'
  },
  finalGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-final-group'
  },
  pilotGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(-3, 9),
    submitted: true,
    submissionDate: getDateOffset(-2, 10),
    taskId: 'task-pilot-group'
  },
  oneOnOneFinalAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-one-on-one-final'
  },
  oneOnOneMidCohortAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-one-on-one-mid'
  }
};

// WHY: Jordan's screenshot persona has already completed onboarding and is carrying one
// realistic follow-up task alongside the active coaching and PowerLab programs.
export const leaderTasks: UserTasksAndResponses = {
  tasksCount: 1,
  termsAndConditions: {
    submitted: true,
    submissionDate: getDateOffset(-45, 9)
  },
  firstAssessment: {
    exists: true,
    dueDate: getDateOffset(-35, 9),
    submitted: true,
    submissionDate: getDateOffset(-34, 10),
    taskId: 'task-first-assessment'
  },
  midCohortGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(4, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-mid-cohort'
  },
  finalGroupAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  pilotGroupAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  oneOnOneFinalAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  oneOnOneMidCohortAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  }
};

// WHY: The CEO persona has completed onboarding and initial coach selection, keeping the Tasks
// surface quiet while the two active 1:1 programs remain the focus of the preview.
export const ceoTasks: UserTasksAndResponses = {
  tasksCount: 0,
  termsAndConditions: {
    submitted: true,
    submissionDate: getDateOffset(-75, 9)
  },
  firstAssessment: {
    exists: true,
    dueDate: getDateOffset(-56, 9),
    submitted: true,
    submissionDate: getDateOffset(-55, 10),
    taskId: 'task-first-assessment'
  },
  midCohortGroupAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  finalGroupAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  pilotGroupAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  oneOnOneFinalAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  },
  oneOnOneMidCohortAssessment: {
    exists: false,
    dueDate: '',
    submitted: false,
    submissionDate: '',
    taskId: ''
  }
};
